export const ProvisioningMapping: Array<object> = [
  {
    name: 'DCM',
    type: 'dcm',
    status: ['dcm.status'],
    message: ['dcm.message'],
    value: [''],
    updatedDate: ['dcm.lastUpdateDate']
  },
  {
    name: 'Telema',
    value: ['dcm.telema'],
    status: [''],
    parent: 'dcm',
    updatedDate: ['']
  },
  {
    name: 'Remote Connect',
    status: [''],
    value: ['dcm.remote'],
    parent: 'dcm',
    updatedDate: ['']
  },
  {
    name: 'Service Connect',
    status: [''],
    value: ['dcm.serviceConnect'],
    parent: 'dcm',
    updatedDate: ['']
  },
  {
    name: 'Head Unit',
    type: 'headunit',
    status: ['headunit.status'],
    message: ['headunit.message'],
    value: [''],
    updatedDate: ['headunit.lastUpdateDate']
  },
  { name: 'CAN300', value: ['headunit.can300'], status: [''], parent: 'headunit', updatedDate: [''] },
  { name: 'Destination Assist', value: ['headunit.destAssist'], status: [''], parent: 'headunit', updatedDate: [''] },
  { name: 'dynamicNavi', value: ['headunit.dynamicNavi'], status: [''], parent: 'headunit', updatedDate: [''] },
  { name: 'Wi-Fi', value: ['headunit.wifi'], status: [''], parent: 'headunit', updatedDate: [''] },
  {
    name: 'Safety Connect',
    type: 'safety',
    status: ['safety.status'],
    message: ['safety.message'],
    value: [''],
    updatedDate: ['safety.lastUpdateDate']
  },
  { name: 'ACN', value: ['safety.acn'], status: [''], parent: 'safety', updatedDate: [''] },
  { name: 'SOS', value: ['safety.sos'], status: [''], parent: 'safety', updatedDate: [''] },
  { name: 'DHC', value: ['safety.dhc'], status: [''], parent: 'safety', updatedDate: [''] },
  { name: 'FOTA', value: ['safety.fota'], status: [''], parent: 'safety', updatedDate: [''] },
  {
    name: 'Plug and Charge',
    type: 'pnc',
    status: ['pnc.status'],
    message: ['pnc.message'],
    value: ['pnc.toggle_status'],
    updatedDate: ['pnc.lastUpdateDate'],
  },
  { name: 'Provisioning Certificate', value: ['pnc.prov_cert'], status: ['pnc.prov_status'], parent: 'pnc', updatedDate: [''] },
  { name: '[Hubject] V2G Root Certificate', value: ['pnc.root_cert'], status: ['pnc.prov_status'], parent: 'pnc', updatedDate: [''] },
  { name: '[Tesla] V2G Root Certificate', value: ['pnc.root_cert'], status: ['pnc.prov_status'], parent: 'pnc', updatedDate: [''] },
  { name: 'Toyota Contract Certficate', value: ['pnc.toy_cert'], status: ['pnc.contract_status'], parent: 'pnc', updatedDate: [''] },
];
